// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1IAEJ","item":"PaymentsMobile_item__3n_3F","label":"PaymentsMobile_label__1QLMs","amount":"PaymentsMobile_amount__IlX4t"};